import React from 'react';
import { cn } from './Button';
export function Card({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('rounded-lg border shadow-sm', className)} style={{
    borderColor: 'var(--border-strong)',
    backgroundColor: 'var(--bg-surface)',
    color: 'var(--text-primary)'
  }} {...props} data-id="element-1054" />;
}